export type AiCostLimitSubjectsPayload = {
	readonly organizations: { id: number; name: string }[];
	readonly facilities: { id: number; name: string }[];
};

export type AiCostLimitSubjectsFetchedAction = {
	type: 'AI_COST_LIMIT_SUBJECTS_FETCHED';
	payload: AiCostLimitSubjectsPayload;
	accountId: number;
};

export default (
	payload: AiCostLimitSubjectsPayload,
	accountId: number,
): AiCostLimitSubjectsFetchedAction => ({
	type: 'AI_COST_LIMIT_SUBJECTS_FETCHED',
	payload,
	accountId,
});
